import { ValidatorFn, AbstractControl } from '@angular/forms';

export function PasswordComplexityValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;

        // Nếu trống
        if (!value || value.trim() === '') {
            return { passwordComplexity: { message: 'Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt' } };
            // return { passwordComplexity: { message: 'Mật khẩu không được để trống' } };
        }

        // Độ dài
        if (value.length < 8) {
            return { passwordComplexity: { message: 'Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt' } };
            // return { passwordComplexity: { message: 'Mật khẩu phải có ít nhất 8 ký tự' } };
        }

        // Kiểm tra từng điều kiện
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumber = /[0-9]/.test(value);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>_\-\\[\];'/+=`~]/.test(value);

        if (!hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecialChar) {
            return { passwordComplexity: { message: 'Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt' } };
        }

        // if (!hasUpperCase) {
        //     return { passwordComplexity: { message: 'Phải có ít nhất 1 chữ hoa' } };
        // }

        // if (!hasLowerCase) {
        //     return { passwordComplexity: { message: 'Phải có ít nhất 1 chữ thường' } };
        // }

        // if (!hasNumber) {
        //     return { passwordComplexity: { message: 'Phải có ít nhất 1 chữ số' } };
        // }

        // if (!hasSpecialChar) {
        //     return { passwordComplexity: { message: 'Phải có ít nhất 1 ký tự đặc biệt' } };
        // }

        // Hợp lệ
        return null;
    };
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/shared/validators/password-complexity.validator.ts